import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_5 = { class: "relative overflow-auto" }
const _hoisted_6 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, " Settings ", -1)
const _hoisted_8 = { class: "pl-[181px] min-h-[500px]" }
const _hoisted_9 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_10 = { class: "flex items-center space-x-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_13 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_15 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_16 = { class: "w-full px-6 border-t py-7" }

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ViewButton from '@/components/buttons/ViewButton.vue';
import DataTable from '../Components/DataTable.vue';
import SideTab from '../Components/SideTab.vue';
import TabComponent from '@/components/partials/TabComponent.vue';

import pickBy from "lodash/pickBy";

import Roles from "@/classes/Roles";

import SimplePagination from "@/components/partials/SimplePagination.vue";

import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import {filters, items} from "@/interfaces/pages/FilterPageInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const loading = ref<boolean>(false);

const route = useRoute();
const router = useRouter();

const tabs: { name: string, count: number, tab: string|null, allowed: boolean }[] = [
    {
        name: 'All',
        count: filters.value.allItemsCount,
        tab: null,
        allowed: true
    }
];

const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Role' },
    { text: 'No. of Assigned Personnel' },
];

const init = () => {
    Roles.index(pickBy(filters.value))
        .then(({ data }) => {
            items.value = data.items;
   
            filters.value = assignValues(filters.value, data);
           
            loading.value = false
        })
        .catch((error: any) => {
            console.log(error);
        });
}

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })
    init();
};

onMounted(() => {
    init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Settings",
            description: "View the relevant data and other details"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(SideTab, { rolesSelected: "" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(TabComponent, { tabs: tabs })
                  ])
                ]),
                (_unref(route).query.tab != 'activity_logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": false,
                        count: _unref(items).total,
                        tableClass: "header-frm-table"
                      }, {
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_12, _toDisplayString(item.name), 1),
                              _createElementVNode("td", _hoisted_13, _toDisplayString(item.no_assigned_personels) + " Personnel ", 1),
                              _createElementVNode("td", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(ViewButton, {
                                    onClick: ($event: any) => (_unref(router).replace(`/settings/roles/view/${item.id}`))
                                  }, null, 8, ["onClick"])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(filters).tab == 'activity_logs')
              ? (_openBlock(), _createBlock(ActivityLogsTable, {
                  key: 0,
                  items: _unref(items)
                }, null, 8, ["items"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(SimplePagination, {
                numRows: _unref(filters).rows,
                currentPage: _unref(items).current_page,
                "last-page": _unref(items).last_page,
                onUpdate: _cache[0] || (_cache[0] = (value) => paginate(value))
              }, null, 8, ["numRows", "currentPage", "last-page"])
            ])
          ])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})